/* tslint:disable */
/* eslint-disable */
/**
 * Common Schemas
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ScreenerSuggestion = {
    Accept: 'Accept',
    Reject: 'Reject',
    Maybe: 'Maybe',
    Pending: 'Pending',
    Cancelled: 'Cancelled',
    NA: 'N/A',
} as const;
export type ScreenerSuggestion = typeof ScreenerSuggestion[keyof typeof ScreenerSuggestion];


export function instanceOfScreenerSuggestion(value: any): boolean {
    for (const key in ScreenerSuggestion) {
        if (Object.prototype.hasOwnProperty.call(ScreenerSuggestion, key)) {
            if (ScreenerSuggestion[key as keyof typeof ScreenerSuggestion] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ScreenerSuggestionFromJSON(json: any): ScreenerSuggestion {
    return ScreenerSuggestionFromJSONTyped(json, false);
}

export function ScreenerSuggestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScreenerSuggestion {
    return json as ScreenerSuggestion;
}

export function ScreenerSuggestionToJSON(value?: ScreenerSuggestion | null): any {
    return value as any;
}

export function ScreenerSuggestionToJSONTyped(value: any, ignoreDiscriminator: boolean): ScreenerSuggestion {
    return value as ScreenerSuggestion;
}

